import { useEffect, useState } from "react";
import { MapPin, Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const FIELDS = [
  { key: "service_radius_km", label: "Free zone radius (km)", hint: "No travel fee inside this" },
  { key: "travel_surcharge", label: "Travel surcharge ($)", hint: "Charged beyond the free zone" },
  { key: "max_travel_km", label: "Hard cap (km)", hint: "Beyond this → waitlist, no deposit" },
];

export default function ServiceAreaSettings() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings/service-area").then((r) => setForm(r.data));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.patch("/admin/settings/service-area", {
        service_radius_km: Number(form.service_radius_km),
        travel_surcharge: Number(form.travel_surcharge),
        max_travel_km: Number(form.max_travel_km),
      });
      setForm(data);
      toast.success("Service area updated");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Save failed");
    } finally {
      setSaving(false);
    }
  };

  if (!form) return null;

  return (
    <div className="mt-12 cj-card p-6" data-testid="service-area-settings">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-xl bg-[#ff6b00]/10 flex items-center justify-center">
          <MapPin className="h-5 w-5 text-[#ff6b00]" />
        </div>
        <div>
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#ff6b00]">Service area</div>
          <div className="font-display uppercase font-extrabold text-xl text-slate-100">Travel rules from {form.home_postcode}</div>
        </div>
      </div>
      <div className="mt-5 grid sm:grid-cols-3 gap-4">
        {FIELDS.map((f) => (
          <div key={f.key}>
            <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-400 mb-1.5">{f.label}</div>
            <input
              type="number"
              value={form[f.key]}
              onChange={(e) => setForm({ ...form, [f.key]: e.target.value })}
              data-testid={`area-setting-${f.key}`}
              className="w-full bg-[#0f1522] border border-white/10 rounded-xl px-4 py-3 text-slate-200 focus:outline-none focus:border-[#ff6b00]"
            />
            <div className="text-xs text-slate-500 mt-1">{f.hint}</div>
          </div>
        ))}
      </div>
      <div className="mt-5 flex justify-end">
        <button onClick={save} disabled={saving} data-testid="area-settings-save-button" className="cj-btn-primary px-5 py-2.5 rounded-full inline-flex items-center gap-2">
          <Save className="h-4 w-4" /> {saving ? "Saving…" : "Save rules"}
        </button>
      </div>
    </div>
  );
}
